/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Tournament_FinishedInputs */



/**
* | output |
* | --- |
* | "Tournament is finished." |
*
* @param {Overview_Tournament_FinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_tournament_finished = /** @type {((inputs?: Overview_Tournament_FinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Tournament_FinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le tournoi est terminé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El torneo ha finalizado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneio finalizado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il torneo è concluso.")
	return /** @type {LocalizedString} */ ("Tournament is finished.")
});